// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { getPostcode, getAddresses }
  from '../../../account/components/AccountTab/components/Address/store/selectors';
import * as searchAddressActions
  from '../../../account/components/AccountTab/components/Address/store/actions';
import {
  Input,
  SearchInput
  // SearchBar 
} from '../../../../components';
import styles from './styles';

class DataContainer extends React.Component {
  state = {};

  render() {
    const { classes } = this.props;
    return (
      <form className={classes.mainContainer}>
        <div className={classes.rowContainer}>
          <Input
            label={'First name:'}
            name={'ForeName'}
            style={classNames(classes.marginRight, classes.inputStyle)}
            value={this.props.profile.ForeName}
            onChange={this.props.changeField}
          />
          <Input
            label={'Last name:'}
            name={'SurName'}
            style={classes.inputStyle}
            value={this.props.profile.SurName}
            onChange={this.props.changeField}
          />
        </div>
        <div className={classes.rowContainer}>
          <Input
            label={'Email:'}
            name={'EmailID'}
            style={classNames(classes.marginRight, classes.inputStyle)}
            value={this.props.profile.EmailID}
            onChange={this.props.changeField}
          />
          <Input
            label={'Postcode:'}
            name={'Postcode'}
            style={classes.inputStyle}
            value={this.props.address.Postcode}
            onChange={this.props.changeFieldAddress}
          />
        </div>
        <div className={classes.rowContainer}>
          {/* <SearchBar
            style={classes.searchInputStyle}
            changeField={this.props.changeFieldSearch}
            onChange={this.props.changeFieldAddress}
            postcode={this.props.postcode}
          /> */}
          <SearchInput
            left={false}
            style={classes.searchInputStyle}
            changeField={this.props.changeFieldSearch}
            searchAddress={this.props.searchAddress}
            postcode={this.props.postcode}
            addresses={this.props.addresses}
            requestSelectedAddress={this.props.requestSelectedAddress}
          />
        </div>
        <div className={classes.rowContainer}>
          <Input
            label={'Address line 1:'}
            name={'AddressLine1'}
            style={classNames(classes.marginRight, classes.inputStyle)}
            value={this.props.address.AddressLine1}
            onChange={this.props.changeFieldAddress}
          />
          <Input
            label={'Address line 2:'}
            name={'AddressLine2'}
            style={classes.inputStyle}
            value={this.props.address.AddressLine2}
            onChange={this.props.changeFieldAddress}
          />
        </div>
        <div className={classes.rowContainer}>
          <Input
            label={'County:'}
            name={'County'}
            style={classNames(classes.marginRight, classes.inputStyle)}
            value={this.props.address.County}
            onChange={this.props.changeFieldAddress}
          />
          <Input
            label={'Town:'}
            name={'Town'}
            style={classes.inputStyle}
            value={this.props.address.Town}
            onChange={this.props.changeFieldAddress}
          />
        </div>
      </form>
    );
  }
}

DataContainer.propTypes = {
  classes: PropTypes.object,
  address: PropTypes.object,
  profile: PropTypes.object,
  addresses: PropTypes.array,
  postcode: PropTypes.string,
  searchAddress: PropTypes.func,
  changeFieldSearch: PropTypes.func,
  requestSelectedAddress: PropTypes.func,
  changeField: PropTypes.func,
  changeFieldAddress: PropTypes.func,
};

DataContainer.defaultProps = {
  classes: {},
  address: {},
  profile: {},
  addresses: [],
  postcode: null,
  searchAddress: () => { },
  changeFieldSearch: () => { },
  requestSelectedAddress: () => { },
  changeField: () => { },
  changeFieldAddress: () => { },
};

const mapStateToProps = (state) => {
  return {
    postcode: getPostcode(state),
    addresses: getAddresses(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeFieldSearch: (value, name) => dispatch(searchAddressActions.changeField(value, name)),
    searchAddress: data => dispatch(searchAddressActions.requestAddressSearch(data)),
    requestSelectedAddress: data => dispatch(searchAddressActions.requestSelectedAddress(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DataContainer));
